export default {
  state: () => ({
    mediaInfo: {}, // 影音管理頁面，編輯/新增語音時的資料
  }),
  getters: {
    mediaInfo(state) {
      return state.mediaInfo;
    },
  },
  mutations: {
    UPDATE_MEDIA_INFO(state, payload) {
      state.mediaInfo = payload.mediaInfo;
    },
  },
  actions: {
    updateMediaInfo({ commit }, payload) {
      commit('UPDATE_MEDIA_INFO', payload);
    },
  },
};
